<!-- 用户数据的头部卡片 -->
<template>
  <div class="head-card">
    <div v-loading="dataloding">
      <div class="filter-content">
        <el-form inline>
          <el-form-item label="用户来源:">
            <el-cascader
              v-model="source"
              :options="sourceOptions"
              :props="{ checkStrictly: true }"
              :clearable="true"
              filterable
            ></el-cascader>
          </el-form-item>
        </el-form>
        <el-button type="primary" @click="clickFilter">筛选</el-button>
      </div>
      <div class="data-overview-box">
        <div v-for="item in keyDataList" :key="item.key" class="data-item">
          <div class="data-item-info">
            <div class="data-from-label">{{ item.label }}</div>
            <div class="data-from-number">
              <span class="data-num">{{ item.data === null ? '--' : item.data }}</span>
              <span class="data-prefix">{{ item.unit }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getAppListApi as GetArticleAppList, // 获取公众号/小程序列表
  GetUserStatPages,
} from '@/api/dataCenter.js';
// import { getAppListApi } from '@/api/setUser';
import { APP_TYPE } from '@/utils/constant';
export default {
  name: 'HeadCard',
  components: {},
  props: {},
  data() {
    return {
      dataloding: false,
      source: [], // 发布来源
      sourceOptions: [
        {
          value: 1,
          label: '公众号',
        },
        {
          value: 2,
          label: '小程序',
        },
        {
          value: 3,
          label: 'H5',
        },
        // {
        //   value: 4,
        //   label: '其他',
        // },
        {
          value: 0,
          label: '全部',
        },
      ],
      keyDataList: [
        {
          key: 'cumulate_num',
          label: '用户总量',
          unit: '人',
          data: null,
        },
        {
          key: 'incre_num',
          label: '近30日新增用户量',
          unit: '人',
          data: null,
        },
        {
          key: 'active_num',
          label: '近30日活跃用户量',
          unit: '人',
          data: null,
        },
      ],
    };
  },
  computed: {
    enterpriseId() {
      return this.$store.getters['user/getEnterpriseId'];
    },
  },
  watch: {
    enterpriseId(newVal) {
      if (newVal) {
        this.getSourceList();
      }
    },
  },
  // 生命周期 - 创建完成（访问当前this实例）
  created() {
    if (this.enterpriseId) {
      this.getSourceList();
    }
    this.getKeyData();
  },
  // 生命周期 - 挂载完成（访问DOM元素）
  mounted() {},
  methods: {
    // 获取发布来源
    async getSourceList() {
      try {
        const res = await GetArticleAppList();
        if (res.data && res.data.length) {
          const mapKey = [
            APP_TYPE.officialAccounts,
            APP_TYPE.miniprogram,
            APP_TYPE.H5,
            APP_TYPE.other,
          ];
          mapKey.forEach((key, index) => {
            this.sourceOptions[index].children = res.data
              .filter((item) => item.app_type === key)
              .map((mapItem) => ({
                value: mapItem.appid,
                label: mapItem.app_name,
              }));
            console.log('this.sourceOptions', this.sourceOptions);
          });
        }
        this.sourceOptions.reverse().reverse();
      } catch (err) {
        this.$message.error('查询发布来源失败');
        console.log('error', err);
      }
    },
    // 获取用户人数、近30日新增人数、近30日活跃人数
    async getKeyData() {
      this.dataloding = true;
      const params = {
        source: this.source.length >= 1 ? this.source[0] : 0, // 渠道， 1-公众号，2-小程序
        appid: this.source.length >= 2 ? this.source[1] : '',
      };
      try {
        const res = await GetUserStatPages(params);
        console.log(111, res);
        if (Object.keys(res).length) {
          this.keyDataList = this.keyDataList.reduce((arr, item, index) => {
            item.data = res[item.key];
            arr[index] = item;
            return arr;
          }, []);
        }
      } catch (err) {
        this.keyDataList = this.keyDataList.reduce((arr, item, index) => {
          item.data = null;
          arr[index] = item;
          return arr;
        }, []);
        console.log(err);
      }
      this.dataloding = false;
    },
    // 点击筛选
    clickFilter() {
      this.getKeyData();
    },
  },
};
</script>
<style lang="scss" scoped>
.head-card {
  .filter-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #eee;
    height: 68px;
    .el-form-item {
      margin-bottom: 0;
    }
  }
  .data-overview-box {
    width: 100%;
    display: flex;
    margin: 24px 0px;
    box-sizing: border-box;
    .data-item {
      flex: 1;
      height: 128px;
      background: #f7f9fc;
      border: 1px solid #2f96ff;
      border-radius: 4px;
      border-top-width: 8px;
      margin-right: 16px;
      .data-item-info {
        padding-top: 28px;
        padding-left: 24px;
        box-sizing: border-box;
        .data-from-label {
          font-family: PingFangSC-Medium;
          font-size: 16px;
          color: #313233;
          line-height: 24px;
        }
        .data-from-number {
          .data-num {
            font-family: PingFangSC-Medium;
            font-size: 30px;
            color: #2f96ff;
          }
          .data-prefix {
            font-family: PingFangSC-Medium;
            font-size: 14px;
            color: #2f96ff;
            padding-left: 8px;
          }
        }
      }
    }
  }
}
</style>
